export const TINT_COLOR_UPDATED_EVENT = 'calculators:tintColorUpdated';
export const TINT_SERVICE_QUANTITY_FOR_ACTIVE_COLOR_UPDATED_EVENT =
  'calculators:tintServiceQuantityForActiveColorUpdated';
